export var ModeName;
(function (ModeName) {
    ModeName["WISHLIST_BAG"] = "wishlist-bag";
    ModeName["WISHLIST_CDP"] = "wishlist-cdp";
    ModeName["WISHLIST_LANDING"] = "wishlist-landing";
    ModeName["WISHLIST_PDP"] = "wishlist-pdp";
    ModeName["BIS_PDP"] = "bis-pdp";
    ModeName["BIS_MY_BAG"] = "bis-my-bag";
    ModeName["WE_MADE_TOO_MUCH_MARKDOWN_PDP"] = "we-made-too-much-markdown-pdp";
    ModeName["SFL_BAG"] = "sfl-bag";
    ModeName["LOGIN_CHECKOUT_MODAL"] = "login-checkout-modal";
    ModeName["CHECKOUT_STEP_ZERO"] = "checkout-step-zero";
    ModeName["DETECT_ACCOUNT"] = "detect-account";
    ModeName["DETECT_ACCOUNT_OCP"] = "detect-account-ocp";
})(ModeName || (ModeName = {}));
export var DETECT_ACCOUNT_MODES = [
    ModeName.DETECT_ACCOUNT,
    ModeName.DETECT_ACCOUNT_OCP
];
